import { useQuery } from "@tanstack/react-query";
import { spySerpService, type SpyserpDateRangeParams } from "@/services/SpySerpService";
import { getSpyserpDateRangeQueryKey } from "@/hooks/spyserp/ensureSpyserpDateRange";

export const useSpyserpDateRange = (params: SpyserpDateRangeParams) =>
  useQuery({
    queryKey: getSpyserpDateRangeQueryKey(params),
    queryFn: () => spySerpService.resolveDateRange(params),
    staleTime: 1000 * 60 * 5,
  });
